export { default } from "./SupportYourTeamBubbleMessage";
